import { render, staticRenderFns } from "./r-trigger-item.vue?vue&type=template&id=21b83515&scoped=true"
import script from "./r-trigger-item.vue?vue&type=script&lang=js"
export * from "./r-trigger-item.vue?vue&type=script&lang=js"
import style0 from "./r-trigger-item.vue?vue&type=style&index=0&id=21b83515&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b83515",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21b83515')) {
      api.createRecord('21b83515', component.options)
    } else {
      api.reload('21b83515', component.options)
    }
    module.hot.accept("./r-trigger-item.vue?vue&type=template&id=21b83515&scoped=true", function () {
      api.rerender('21b83515', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/trigger/r-trigger-item.vue"
export default component.exports